import React from "react";
import { usePanelTheme } from "../context/themeContext";

export default function UISelect({
  value,
  onChange,
  children,
  className = "",
  ...props
}) {
  const { theme } = usePanelTheme();

  const base = `
  h-12 w-full rounded-2xl border px-4 text-sm outline-none transition
  focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10
  `;

  const light =
    "border-slate-200 bg-slate-50 text-slate-900 focus:bg-white";

  const dark =
    "border-slate-700 bg-slate-900 text-slate-100";

  return (
    <select
      value={value}
      onChange={onChange}
      className={`${base} ${theme === "dark" ? dark : light} ${className}`}
      {...props}
    >
      {children}
    </select>
  );
}